import * as Yup from "yup";

export const table = {
  primaryData: [
    {
        title: "ID",
        value: "id",
        type: "configue",
    },
    {
        title: "First Name",
        value: "firstName",
        type: "configue",
    },
    {
        title: "Last Name",
        value: "lastName",
        type: "configue",
    },
    {
        title: "Email",
        value: "email",
        type: "configue",
    },
    {
      title: "Associated Domain Name",
      value: "associatedDomainName",
      type: "configue",
    },
    {
      title: "External User ID",
      value: "externalUserId",
      type: "configue",
    },
    {
        title: "Capabilities",
        value: "capabilitiesCapacity",
        type: "configue",
    },
    {
        title: "User Type",
        value: "userType",
        type: "configue",
    },
  ],
  secondaryData: [
    {
        title: "Role Name",
        value: "roleName",
        type: "configue",
    },
    {
        title: "Is Active",
        value: "isActive",
        type: "boolean",
        
    },
    {
      title: "Is Used",
      value: "isUsed",
      type: "boolean",
    },
    {
        title: "Created At",
        value: "createdAt",
        type: "date",
    },
    {
        title: "Updated At",
        value: "updatedAt",
        type: "date",
        name: "updatedAt"
    },
    {
        title: "Created By",
        value: "createdByName",
        type: "configue"
    },
    {
        title: "Updated By",
        value: "updatedByName",
        type: "configue",
        name: "updatedByName"
    }
  ],
};

export type vendorUser = {
      id: string,
      vendorAccountId: string,
      vendorUserId: string,
      userType: string,
      roleName: string,
      firstName: string,
      lastName: string,
      email: string,
      userMetadata: string,
      isUsed: boolean,
      isActive: boolean,
      createdAt: string,
      updatedAt: string,
      createdById: string,
      updatedById: string,
      createdByName: string,
      updatedByName: string, 
};

export const vendorUserInitialValues: vendorUser= {
      id:"",
      vendorAccountId : "",
      vendorUserId : "",
      userType : "",
      roleName : "",
      firstName : "",
      lastName : "",
      email : "",
      userMetadata : "",
      isUsed : false,
      isActive : false,
      createdAt: "",
      updatedAt: "",
      createdById: "",
      updatedById: "",
      createdByName: "",
      updatedByName: "",
};

export const vendorUserMandatoryFields = [{ id: "email" }];

export const vendorUserValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export const vendorUserProperties = [
  {
    id: "id",
    type: "text",
    label: `ID`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "firstName",
    type: "text",
    label: `First Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "lastName",
    type: "text",
    label: `Last Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "email",
    type: "email",
    label: `Email`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
 {
  id: "userType",
  type: "select",
  label: `User Type`,
  className: "name-styles",
  breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
  required: true,
  options: [
    { label: "Admin", value: "admin" },
    { label: "User", value: "user" },
  ],
 },
  {
    id: "roleName",
    type: "text",
    label: `Role Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "isActive",
    type: "checkbox",
    label: `Active`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "createdAt",
    type: "date-picker",
    label: `Created At`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedAt",
    type: "date-picker",
    label: `Updated At`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "createdByName",
    type: "text",
    label: `Created By Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedByName",
    type: "text",
    label: `Updated By Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  }
];